module.exports = __webpack_public_path__ + "img/gettyimages-g.197e8c41.svg";